import { Rarity } from '__generated__/globalTypes';
import { Shards } from 'atoms/icons/Shards';
import { isSupportedCardSet } from 'lib/cardSets';
import { getRarityShardColor } from 'lib/colors';
import type { unitMapping } from 'lib/style';

type Props = {
  cardSetSlug?: string | null;
  size?: keyof typeof unitMapping;
  className?: string;
  gradient?: 'purple';
};
export const CommonShards = ({
  cardSetSlug,
  size = 2,
  className,
  gradient,
}: Props) => {
  const shardColor = getRarityShardColor(
    Rarity.common,
    isSupportedCardSet(cardSetSlug) ? cardSetSlug : null
  );
  return (
    <Shards
      color={shardColor}
      size={size}
      className={className}
      gradient={gradient}
    />
  );
};
